const middleware = {}

middleware['site'] = require('../middleware/site.js')
middleware['site'] = middleware['site'].default || middleware['site']

export default middleware
